import {
    getChats,
    getChatUsers,
    createChat,
    deleteChat,
    removeChatMember,
    addChatMembers,
    getMessages,
    sendMessage,
    editMessage,
    deleteMessage,
    searchMessages,
    uploadAttachment,
    markChatRead,
    markMessageRead,
    muteChat,
    chatDeletedEvent,
    chatMemberRemovedEvent,
    chatMembersAddedEvent,
    chatReceiveMessage,
    chatUnreadUpdate,
    chatMessageEdited,
    chatMessageDeleted,
    chatMessageRead,
    chatSetTyping,
    chatClearTyping,
    setActiveChat,
    clearActiveChat,
    clearMessages,
    clearChatUsers,
} from './chat.action';
export { chatReducer } from './chat.reducer';
export { watchChat } from './chat.saga';

export const chatActions = {
    getChats,
    getChatUsers,
    createChat,
    deleteChat,
    removeChatMember,
    addChatMembers,
    getMessages,
    sendMessage,
    editMessage,
    deleteMessage,
    searchMessages,
    uploadAttachment,
    markChatRead,
    markMessageRead,
    muteChat,
    chatDeletedEvent,
    chatMemberRemovedEvent,
    chatMembersAddedEvent,
    chatReceiveMessage,
    chatUnreadUpdate,
    chatMessageEdited,
    chatMessageDeleted,
    chatMessageRead,
    chatSetTyping,
    chatClearTyping,
    setActiveChat,
    clearActiveChat,
    clearMessages,
    clearChatUsers,
};
